import AfterSalesLayout from "../aftersaleslayout/AfterSalesLayout";
import FallbackImg from "../../../components/FallbackImg";
import BackBlue from "../../../assets/aftersalesservice_icons/back_blue_icon.svg";
import UserManualSafetyIcon from "../../../assets/aftersalesservice_icons/user_manual_safety_icon.svg";
import RedSafety from "../../../assets/aftersalesservice_icons/red_safety_icon.png";
import CautionIcon from "../../../assets/aftersalesservice_icons/caution_icon.png";
import GeneralIcon from "../../../assets/aftersalesservice_icons/general_safety_icon.svg";
import Gen1 from "../../../assets/aftersalesservice_icons/general_safety_1_icon.svg";
import Gen2 from "../../../assets/aftersalesservice_icons/general_safety_2_icon.svg";
import Gen3 from "../../../assets/aftersalesservice_icons/general_safety_3_icon.svg";
import ElecIcon from "../../../assets/aftersalesservice_icons/electrical_safety_icon.svg";
import Elec1 from "../../../assets/aftersalesservice_icons/electrical_safety_1_icon.svg";
import Elec2 from "../../../assets/aftersalesservice_icons/electrical_safety_2_icon.svg";
import Elec3 from "../../../assets/aftersalesservice_icons/electrical_safety_3_icon.svg";
import FireWhite from "../../../assets/aftersalesservice_icons/fire_white_icon.svg";
import FireRed from "../../../assets/aftersalesservice_icons/fire_red_icon.svg";
import Emergency from "../../../assets/aftersalesservice_icons/emergency_icon.png";
import { useLanguage } from "../LanguageContext";

const UserManualSafety = () => {
  const { trans } = useLanguage();

  return (
    <AfterSalesLayout>
      <div
        className="as-user-manual-safety-content"
        id="user_manual_safety_modal"
      >
        <div style={{ padding: "0 31.97px" }}>
          <div className="as-user-manual-safety-container">
            <button
              type="button"
              className="as-back-btn"
              id="user_manual_safety_back"
              onClick={() => window.history.back()}
            >
              <FallbackImg src={BackBlue} alt="back_blue_icon" />
              {trans.back_manual}
            </button>

            <div className="as-user-manual-safety-main">
              <FallbackImg
                src={UserManualSafetyIcon}
                alt="user_manual_safety_icon"
              />
              <div>
                <div className="as-user-manual-safety-main-title">
                  {trans.safety_precaut}
                </div>
                <div className="as-user-manual-safety-main-text">
                  {trans.safety_precaut_sub}
                </div>
              </div>
            </div>
          </div>

          <div className="as-red-safety-container">
            <FallbackImg src={RedSafety} alt="red_safety_icon" />
            <div>
              <div className="as-red-safety-text-container">
                <FallbackImg src={CautionIcon} alt="caution_icon" />
                {trans.your_safety}
              </div>
              <div className="as-red-safety-text">{trans.your_safety_sub}</div>
            </div>
          </div>

          <div className="as-general-safety-container">
            <div className="as-general-safety-title">
              <FallbackImg src={GeneralIcon} alt="general_safety_icon" />
              <div>{trans.general_safety}</div>
            </div>
            <div className="as-general-safety-box">
              <FallbackImg src={Gen1} alt="general_safety_1_icon" />
              <div>{trans.general_safety_sub_1}</div>
            </div>
            <div className="as-general-safety-box">
              <FallbackImg src={Gen2} alt="general_safety_2_icon" />
              <div>{trans.general_safety_sub_2}</div>
            </div>
            <div className="as-general-safety-box">
              <FallbackImg src={Gen3} alt="general_safety_3_icon" />
              <div>{trans.general_safety_sub_3}</div>
            </div>
          </div>

          <div className="as-electrical-safety-container">
            <div className="as-electrical-safety-title">
              <FallbackImg src={ElecIcon} alt="electrical_safety_icon" />
              <div>{trans.elec_safety}</div>
            </div>
            <div className="as-electrical-safety-box">
              <div className="as-electrical-safety-text">
                <FallbackImg src={Elec1} alt="electrical_safety_1_icon" />
                <div>{trans.elec_safety_sub_1}</div>
              </div>
              <div className="as-electrical-safety-text">
                <FallbackImg src={Elec2} alt="electrical_safety_2_icon" />
                <div>{trans.elec_safety_sub_2}</div>
              </div>
              <div className="as-electrical-safety-text">
                <FallbackImg src={Elec3} alt="electrical_safety_3_icon" />
                <div>{trans.elec_safety_sub_3}</div>
              </div>
            </div>
          </div>

          <div className="as-refrigerant-notice-container">
            <div className="as-refrigerant-notice-title">
              <div className="as-refrigerant-notice-btn">{trans.danger}</div>
              <div>{trans.refrig_notice}</div>
            </div>
            <div className="as-refrigerant-notice-text">
              <div className="as-refrigerant-notice-text-btn">
                <FallbackImg src={FireWhite} alt="fire_white_icon" />
              </div>
              <div>
                <div className="as-refrigerant-notice-text-red">
                  {trans.refrig_notice_sub_1}
                </div>
                <div className="as-refrigerant-notice-subtext">
                  {trans.refrig_notice_sub_2}
                </div>
              </div>
            </div>
            <div className="as-refrigerant-notice-box">
              <FallbackImg src={FireRed} alt="fire_red_icon" />
              <div>{trans.refrig_notice_sub_3}</div>
            </div>
            <div className="as-refrigerant-notice-box">
              <FallbackImg src={FireRed} alt="fire_red_icon" />
              <div>{trans.refrig_notice_sub_4}</div>
            </div>
            <div className="as-refrigerant-notice-box">
              <FallbackImg src={FireRed} alt="fire_red_icon" />
              <div>{trans.refrig_notice_sub_5}</div>
            </div>
          </div>

          <div className="as-emergency-container">
            <FallbackImg src={Emergency} alt="emergency_icon" />
            <div>
              <div className="as-emergency-text">{trans.emerg}</div>
              <div className="as-emergency-subtext">{trans.emerg_sub_1}</div>
              <div className="as-emergency-subtext">{trans.emerg_sub_2}</div>
              <div className="as-emergency-subtext">{trans.emerg_sub_3}</div>
            </div>
          </div>
        </div>
      </div>
    </AfterSalesLayout>
  );
};

export default UserManualSafety;
